import { defineStore } from 'pinia';
import { organization } from '../lib/nucleus'; // replace with your real API client

// The org the startup batch already fetched for this user. The router guard
// takes it once, for the navigation the page loads on, and checks every org
// after that with the API as before. Kept out of the state on purpose: the
// store is persisted to localStorage and a reload must check the org again.
// reset() clears it, so a logout leaves nothing behind.
let validatedOrgId = null;

export const useOrganizationStore = defineStore('organization', {
  state: () => ({
    orgId: null,
    name: null,
    orgData: null,
    loading: false,
    error: null,
  }),

  actions: {
    async reset() {
      this.orgId = null;
      this.name = null;
      this.orgData = null;
      this.loading = false;
      this.error = null;
      validatedOrgId = null;
    },
    // Takes an org the API already returned for the current user (startup
    // batch) and makes it the current one.
    setValidatedOrganization(org) {
      this.orgId = org._id;
      this.orgData = org;
      this.name = org.name;
      this.error = null;
      validatedOrgId = org._id;
    },
    // True once, when the store holds this org from the startup batch; the
    // router guard skips its lookup for that navigation only.
    takeValidatedOrganization(orgId) {
      const taken = !!orgId && this.orgId === orgId && validatedOrgId === orgId;
      validatedOrgId = null;
      return taken;
    },
    async setOrgIdAndFetch(orgId, { force = false } = {}) {
      if (!orgId || (!force && this.orgId === orgId && this.orgData?._id === orgId)) return;

      this.orgId = orgId;
      this.loading = true;
      this.error = null;

      try {
        const response = await organization.getOrganization(orgId);
        if (!response?.data?._id) {
          throw new Error('Organization not found');
        }
        this.orgData = response.data;
        this.name = this.orgData.name;
      } catch (err) {
        this.orgData = null;
        this.error = err;
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
  persist: true
});
